import { render, staticRenderFns } from "./PageManager.vue?vue&type=template&id=3f094e03&scoped=true"
import script from "./PageManager.vue?vue&type=script&lang=js"
export * from "./PageManager.vue?vue&type=script&lang=js"
import style0 from "./PageManager.vue?vue&type=style&index=0&id=3f094e03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f094e03",
  null
  
)

export default component.exports